export const INTEGRATED_APP_HOME_PAGE_URL_PREFIX = "integration-app"
